<template>
  <div class="container">
    <modal name="res" width="300px" class="custom-form">
      <u-list-res :list="resList" :category="resCat"></u-list-res>
    </modal>
    <modal
      name="fback"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      width="1200px"
    >
      <stepper :options="feedbackOptions" v-model="feedbackStep" class="mod">
        <div slot="step-0">
          <uform>
            <ulabel size="12">
              <uinput
                placeholder="Full name for certificate *"
                suggest=""
                v-model="feedbackInput.full_name"
              ></uinput>
            </ulabel>
            <!-- <ulabel size="12">
              <uinput
                placeholder="What aspects of the training could be improved?*"
                v-model="feedbackInput.improve"
                suggest=""
              ></uinput>
            </ulabel> -->
            <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
          </uform>
        </div>
        <div slot="step-1">
          <uform class="fd-form">
            <ulabel size="12">
              The trainer was well prepared and able to meet my learning
              expectations*
              <u-single-select
                v-model="feedbackInput.encouraged"
                :items="feedbackSelect"
              ></u-single-select>
            </ulabel>
            <!-- <ulabel size="6">
              This training will be useful in my work *
              <u-single-select
                v-model="feedbackInput.useful"
                :items="feedbackSelect"
              ></u-single-select>
            </ulabel> -->
            <ubtn @click.prevent.native="prev" :loading="loading"
              >Previous</ubtn
            >
            <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
          </uform>
        </div>
        <div slot="step-2">
          <uform>
            <ulabel size="12">
              Why are you attending the Workshop?*
              <u-single-select
                v-model="feedbackInput.prepared"
                :items="feedbackWhy"
              ></u-single-select>
            </ulabel>
            <!-- <ulabel size="6">
              The trainer fulfilled my learning expectations *
              <u-single-select
                v-model="feedbackInput.prepared"
                :items="feedbackSelect"
              ></u-single-select>
            </ulabel> -->
            <ubtn @click.prevent.native="prev" :loading="loading"
              >Previous</ubtn
            >
            <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
          </uform>
        </div>
        <div slot="step-3">
          <uform>
            <ulabel size="12">
              How did you hear about this session? *
              <uselect
                v-model="feedbackInput.why_attend"
                :items="feedbackReference"
              ></uselect>
            </ulabel>
            <!-- <ulabel size="6">
              How did you hear about this session? *
              <uselect
                v-model="feedbackInput.reference"
                :items="feedbackReference"
              ></uselect>
            </ulabel> -->
            <ubtn @click.prevent.native="prev" :loading="loading"
              >Previous</ubtn
            >
            <ubtn @click.prevent.native="submitFeedback" :loading="loading"
              >Submit</ubtn
            >
          </uform>
        </div>
        <div slot="step-4">
          <uform>
            <ulabel size="12">
              <uinput
                placeholder="What additional Upskill training would you like to have in the future? *"
                suggest=""
                v-model="feedbackInput.additonal_training"
              ></uinput>
            </ulabel>
            <!-- <ulabel size="12">
              <uinput
                placeholder="What aspects of the training could be improved?*"
                v-model="feedbackInput.improve"
                suggest=""
              ></uinput>
            </ulabel> -->
            <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
          </uform>
        </div>
        <div slot="step-5">
          <uform>
            <ulabel size="12">
              Would you recommend Upskill to your friends and colleagues ? *
              <uselect
                v-model="feedbackInput.recommend"
                :items="feedbackReference"
              ></uselect>
            </ulabel>
            <!-- <ulabel size="6">
              How did you hear about this session? *
              <uselect
                v-model="feedbackInput.reference"
                :items="feedbackReference"
              ></uselect>
            </ulabel> -->
            <ubtn @click.prevent.native="prev" :loading="loading"
              >Previous</ubtn
            >
            <ubtn @click.prevent.native="submitFeedback" :loading="loading"
              >Submit</ubtn
            >
          </uform>
        </div>
      </stepper>
    </modal>
    <modal
      name="uvideo"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      width="400px"
    >
      <!--      <u-video :options="videoOptions" id="corsvid"></u-video>-->
      <div
        style="display: flex; justify-content: center; align-content: center; font-size: 20px; color: #0B2A5A; padding: 20px;"
      >
        Coming soon!
      </div>
    </modal>

    <userHeader
      :name="user.name"
      :phn="user.phone"
      :email="user.email"
    ></userHeader>

    <Stat :sumHr="sum" :compWrk="completed" :pendingWrk="pending"></Stat>
    <certBanner></certBanner>
    <!-- <wrkCard :compWrk="completed" :pendingWrk="pending"></wrkCard> -->
    <div class="container">
      <div class="main-layout">
        <div class="wrk-wrapper">
          <div class="workshop_desc">
            <vue-tabs
              type="pills"
              active-tab-color="#0062FF"
              active-text-color="white"
            >
              <v-tab title="UPCOMING COURSES">
                <div class="wrk-content">
                  <div class="wrk-card" v-if="pending.length > 0">
                    <div class="container-1350">
                      <div>
                        <div v-for="(w, ind) in pending" :key="ind">
                          <u-card-user
                            v-if="
                              !(
                                w.bools.completed &&
                                !w.bools.feedback &&
                                !w.bools.paid
                              )
                            "
                            :workshop="w"
                            class="mb-4"
                            @resource="showres"
                            @feedback="feedback"
                          ></u-card-user>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center my-5" v-else>
                    <h5>
                      No registered course! Click
                      <a href="https://upskill.com.bd">here</a> to browse
                      workshops
                    </h5>
                  </div>
                </div>
              </v-tab>

              <v-tab title="PREVIOUS COURSES">
                <div class="wrk-content">
                  <div class="" v-if="filteredCompleted.length > 0">
                    <div class="container-1350">
                      <div class="wrk-card">
                        <div v-for="(w, ind) in filteredCompleted" :key="ind">
                          <u-card-user
                            :workshop="w"
                            class="mb-4"
                            @resource="showres"
                            @feedback="feedback"
                          ></u-card-user>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center my-5" v-else>
                    <h5>
                      No previous course! Click
                      <a href="https://upskill.com.bd">here</a> to browse
                      workshops
                    </h5>
                  </div>
                </div>
              </v-tab>
            </vue-tabs>
          </div>
        </div>
        <div>
          <button
            @click="setDates"
            class="calendarView btn btn-primary btn-calendar"
          >
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
            View All Class Dates
          </button>
          <vc-calendar :attributes="attributes" is-expanded id="viewCalendar" />
          <sideBar></sideBar>
          <div
            style="font-size: 16px;  color: grey; text-align: center; margin: 10px;"
          >
            Helpline: <br />
            <i class="fa fa-phone fa-lg mr-2 mt-2"></i>
            <a href="tel:+8801714053213" style="color: grey;">01714053213</a>
            <br />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="pending.length <= 0 && filteredCompleted.length <= 0"
      style="display: flex; justify-items: center; justify-content: center"
    >
      <h3 style="margin: 150px;">No data available</h3>
    </div>
    <u-chat class="my-5" :ws="filteredChat" :key="filteredChat.length"></u-chat>
    <payHist :paymt="payments"></payHist>
  </div>
</template>

<script>
import moment from 'moment'
import Alert from 'sweetalert2'
import Stepper from '../components/Stepper'
import Stat from '../components/userProfile/stats.vue'
import certBanner from '../components/userProfile/certbanner.vue'
import userHeader from '../components/userProfile/userHeader.vue'
//import wrkCard from "../components/userProfile/wrkCard";
import payHist from '../components/userProfile/payHistory'
import sideBar from '../components/userProfile/sideBar'

export default {
  components: {
    Stepper,
    Stat,
    certBanner,
    userHeader,
    payHist,
    sideBar,
    //wrkCard
  },
  computed: {
    filteredCompleted() {
      if (this.completed.length > 0) {
        return this.completed.filter((w) => w.bools.paid || w.fee == 0)
      } else {
        return []
      }
    },
    filteredChat() {
      let arr = [...this.completed, ...this.pending]
      if (arr.length > 0) {
        return arr.filter((w) => w.bools.paid || w.fee == 0)
      } else {
        return []
      }
    },
    attributes() {
      return [
        // This is a single attribute
        {
          // An optional key can be used for retrieving this attribute later,
          // and will most likely be derived from your data object
          // Attribute type definitions
          highlight: true, // Boolean, String, Object
          // We use a single date here, but it could also be an array of dates,
          //  a date range or a complex date pattern.
          dates: this.cDate,
        },
      ]
    },
  },
  data() {
    return {
      cDate: [],
      classDates: [],
      videoOptions: {
        fluid: true,
        autoplay: true,
        controls: true,
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
      },
      resList: [{ date: '', title: '', link: '' }],
      feedbackInput: {},
      passwords: {},
      sampleWs: {
        category: 'live online',
        duration: '1',
        fee: 0,
        id: 91,
        image:
          '/storage/workshop_cover/bJQY73ADfAeWw0Pz7jIFUPue9oPj03T2zNDQ2C1P.jpeg',
        instructor: 6,
        location: 'Link will be sent to your mail before the session.',
        name: 'Free Live Online Session “Managing Cash Flow in Down Market”',
        status: 5,
        workshop_ts: '2020-04-13 16:00:00',
      },
      profileStatus: [],
      payments: [],
      pending: [],
      completed: [],
      user: { name: '', phone: '', email: '' },
      workshops: [],
      joins: [],
      sum: 0,
      resources: [],
      resdata: [],
      resCat: '',
      feedbackLoading: false,
      loading: false,
      feedbackStep: 0,
      selectedFeedbackWorkshop: {},
      feedbackOptions: {
        headers: [
          {
            title: 'Feedback',
            subtitle: 'Please provide details about yourself',
            img: require('../assets/images/about.png'),
          },
          {
            title: 'Feedback',
            subtitle: 'Experience',
            img: require('../assets/images/about.png'),
          },
          {
            title: 'Feedback',
            subtitle: '(Pick multiple categories if applicable)',
            img: require('../assets/images/about.png'),
          },
          {
            title: 'Feedback',
            subtitle: '(Pick multiple categories if applicable)',
            img: require('../assets/images/about.png'),
          },
        ],
      },
      feedbackWhy: [
        'To improve my skills',
        'To apply it in my workplace',
        'To increase my earning',
        'Other',
      ],
      feedbackSelect: ['Disagree', 'Neutral', 'Agree'],
      feedbackReference: [
        'Facebook',
        'Word of mouth',
        'LinkedIn',
        'Google',
        'Blogs & Articles',
        'Events & News',
      ],
      feedbackRecommend: ['Yes', 'NO'],
      hasBilling: true,
      billingInfo: { street: '', city: '', state: '', zip: '' },
    }
  },
  methods: {
    getDates(id) {
      this.$upskill.getClassesByWID(id).then((res) => {
        if (res.data.data) {
          let d = res.data.data
          d.forEach((el) => {
            this.cDate.push(el.date)
          })
        }
      })
    },
    setDates() {
      const wrk = this.pending.concat(this.filteredCompleted)
      wrk.forEach((w) => {
        this.getDates(w.id)
      })
      var tag = document.getElementById('viewCalendar')
      tag.style.display = tag.style.display === 'block' ? 'none' : 'block'
    },
    getDate(value) {
      this.cDate = value
      // console.log(this.cDate);
      // var tag = document.getElementById("calendar");
      // tag.style.display = tag.style.display === "block" ? "none" : "block";
    },
    next() {
      if (this.feedbackStep == 0 && !this.feedbackInput.full_name) {
        this.ErrorAlert('Please enter your full name!')
        return
      }
      if (this.feedbackStep == 1 && !this.feedbackInput.encouraged) {
        this.ErrorAlert('Please answer the question to proceed!')
        return
      }
      if (this.feedbackStep == 2 && !this.feedbackInput.prepared) {
        this.ErrorAlert('Please answer the question to proceed!')
        return
      }
      if (this.feedbackStep == 3 && !this.feedbackInput.why_attend) {
        this.ErrorAlert('Please answer the question to proceed!')
        return
      }
      if (this.feedbackStep == 4 && !this.feedbackInput.additional_training) {
        this.ErrorAlert('Please answer the question to proceed!')
        return
      }
      this.feedbackStep++
    },
    prev() {
      if (this.feedbackStep > 0) {
        this.feedbackStep--
      }
    },
    showres(e) {
      this.resources = e // returns type, workshop
      // console.log(e.workshop.id)
      let found = this.resdata.find((o) => o.workshop_id == e.workshop.id)
      if (found) {
        let parsed = JSON.parse(found.resources)
        this.resList = parsed.data
        this.resCat = e.type
      } else {
        this.resList = []
        this.resCat = e.type
      }
      // console.log(this.resList)
      // {date:"test date", title: "test title", link: "link test"},
      if (e.type == 'video') {
        this.$modal.show('uvideo')
      } else {
        this.$modal.show('res')
      }
    },
    changePassword() {
      Alert.fire({
        title: 'Change Password',
        html:
          '<input id="p-inp" class="swal2-input" placeholder="New Password" type="password">' +
          '<input id="cp-inp" class="swal2-input" placeholder="Confirm New Password" type="password">',
        focusConfirm: false,
        preConfirm: () => {
          return [
            document.getElementById('p-inp').value,
            document.getElementById('cp-inp').value,
          ]
        },
      }).then((res) => {
        if (res.value[0] && res.value[1]) {
          if (res.value[0] !== res.value[1]) {
            this.ErrorAlert("Password doesn't match!")
          } else {
            this.$upskill
              .passwordChange({ password: res.value[0] })
              .then(() => {
                this.SuccessAlert('Password changed successfully!')
              })
              .catch(() => {
                this.ErrorAlert('Something went wrong! Try again later.')
              })
          }
        }
      })
    },
    changeBilling() {
      Alert.fire({
        title: 'Billing Address',
        html:
          `Address <input id="str-inp" class="swal2-input" placeholder="Address" type="text" value="${this.billingInfo.street}">` +
          `City <input id="cit-inp" class="swal2-input" placeholder="City" type="text" value="${this.billingInfo.city}">` +
          `Town/Post Office <input id="sta-inp" class="swal2-input" placeholder="Town/Post Office" type="text" value="${this.billingInfo.state}">` +
          `Postal Code <input id="zip-inp" class="swal2-input" placeholder="Postal Code" type="text" value="${this.billingInfo.zip}">`,
        focusConfirm: false,
        confirmButtonText: 'Submit',
        preConfirm: () => {
          return [
            document.getElementById('str-inp').value,
            document.getElementById('cit-inp').value,
            document.getElementById('sta-inp').value,
            document.getElementById('zip-inp').value,
          ]
        },
      }).then((res) => {
        if (res.value[0] && res.value[1] && res.value[2] && res.value[3]) {
          if (this.hasBilling === true) {
            this.$upskill
              .updateBilling({
                street: res.value[0],
                city: res.value[1],
                state: res.value[2],
                zip: res.value[3],
              })
              .then(() => {
                this.SuccessAlert('Billing address updated successfully!')
              })
          } else {
            this.$upskill
              .addBilling({
                street: res.value[0],
                city: res.value[1],
                state: res.value[2],
                zip: res.value[3],
              })
              .then(() => {
                this.SuccessAlert('Billing address added successfully!')
              })
          }
        } else {
          this.ErrorAlert('All the fields are required')
        }
      })
    },
    GetResources() {
      return this.$upskill.resources()
    },
    Init() {
      let wpending = []
      let wcompleted = []
      this.$upskill.userProfileStatus().then((res) => {
        this.profileStatus = res.data.data
        this.$upskill.registeredFor().then((res) => {
          this.workshops = res.data.data.filter(
            (co) => co.category != 'Education'
          )
          this.workshops.forEach((w) => {
            if (!isNaN(parseInt(w.duration))) {
              this.sum += parseInt(w.duration)
            }
            if (moment(w.workshop_ts).isBefore(moment.now())) {
              w.image = w.image.startsWith('workshop_cover')
                ? '/storage/' + w.image
                : w.image.replace('public', '/storage')

              let jd = this.profileStatus.find((j) => j.wid == w.id)
              w.bools = {
                paid: false,
                feedback: false,
                completed: true,
              }
              if (jd) {
                w.bools.paid = jd.bools.paid
                w.bools.feedback = jd.bools.certificate
                w.certLink = jd.certLink
                if (w.bools.paid) {
                  this.payments.push({
                    id: jd.wid,
                    via: 'bKash',
                    amount: jd.completed,
                    name: w.name,
                    time: `Discount: ${jd.discount}, Payable: ${jd.payable}`,
                  })
                }
              }
              wcompleted.push(w)
            } else {
              w.image = w.image.startsWith('workshop_cover')
                ? '/storage/' + w.image
                : w.image.replace('public', '/storage')
              let jd = this.profileStatus.find((j) => j.wid == w.id)
              w.bools = {
                paid: false,
                feedback: false,
                completed: false,
              }
              if (jd) {
                w.bools.paid = jd.bools.paid
                w.bools.feedback = jd.hascert
                w.certLink = jd.certlink
                if (w.bools.paid) {
                  this.payments.push({
                    id: jd.wid,
                    via: 'bKash',
                    amount: jd.completed,
                    name: w.name,
                    time: `Discount: ${jd.discount}, Payable: ${jd.payable}`,
                  })
                }
              }
              wpending.push(w)
            }
          })
          this.pending = wpending
          this.completed = wcompleted
        })
      })
    },
    feedback(e) {
      // console.log(e)
      this.selectedFeedbackWorkshop = e
      this.feedbackOptions.headers[0].subtitle = e.name
      this.$modal.show('fback')
    },
    submitFeedback() {
      this.loading = true
      this.feedbackInput.created = new Date().toUTCString()
      let form = {
        wid: this.selectedFeedbackWorkshop.id,
        feedback: JSON.stringify(this.feedbackInput),
      }
      this.$upskill
        .userProfileCert(form)
        .then(() => {
          this.feedbackInput = {}
          this.feedbackStep = 0
          // this.Init();
          this.$modal.hide('fback')
          this.loading = false
          this.Init()
        })
        .catch(() => {
          this.$modal.hide('fback')
        })
    },
    getBillingInfo() {
      this.$upskill
        .getBilling()
        .then((res) => {
          this.billingInfo = res.data.message
        })
        .catch(() => {
          this.hasBilling = false
        })
    },
    created() {
      let t = localStorage.getItem('token')
      if (!t) {
        this.Goto({ name: 'error' })
      }
      this.Loaded()
      this.Init()
      this.GetResources().then((res) => {
        this.resdata = res.data.status || []
      })
      this.getBillingInfo()
      this.user = JSON.parse(localStorage.getItem('userInfo'))
    },
  },
  created() {
    // this.$modal.show("uvideo")
    this.$upskill
      .tokenToUser()
      .then((res) => {
        let info = res.data
        this.userInfo = info
        this.userLoggedIn = true
        localStorage.setItem('userInfo', JSON.stringify(info))
        this.created()
      })
      // eslint-disable-next-line no-unused-vars
      .catch((err) => {
        this.RemoveToken()
      })
    // this.created()
  },
}
</script>

<style scoped>
#viewCalendar {
  display: none;
}
.calendarView {
  margin-top: 2em;
}
.btn-calendar {
  width: 100%;
  margin-bottom: 1em;
  font-weight: 600;
}
.custom-form {
  width: 650px;
}
.wrk-wrapper {
  max-width: 850px;
}

.consultant-stat {
  max-width: 1300px;
  margin: 0 auto;
}
.info-first {
  /* background-color: brown; */
  display: flex;
  justify-content: space-between;
  padding-left: 50px;
  padding-right: 56px;
}
.main-layout {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.9fr 1fr;

  grid-gap: 45px;
}
.tabs-h {
  font-family: 'Montserrat', sans-serif;
}
.cb-tab {
  /* background-color: #0062ff1a; */
  border-radius: 10px;
}
.tab-header {
  display: flex;
  justify-content: space-around;
}
.cb-tab .tab-header li.active {
  background-color: #0062ff;
  color: whitesmoke;
  border-radius: 10px;
  padding: 0.5em;
}
.cb-tab ul li.active {
  border-bottom: none;
}
.chat-window {
  width: 500px;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: auto;
}
.ualert {
  color: dodgerblue;
  margin-bottom: 20px;
}
.badger {
  flex: 0 0 125px;
  text-align: right;
}
@media only screen and (max-width: 600px) {
  .mod {
    height: 40%;
  }

  .main-layout {
    display: grid;
    grid-template-columns: 1fr;
    place-items: center;
    margin-bottom: 50px;
  }
  .consultant-stat {
    max-width: 1300px;
    margin: 0 auto;
  }
  .info-first {
    /* background-color: brown; */
    display: flex;
    justify-content: space-between;
    padding-left: 50px;
    padding-right: 56px;
  }
  .chat-window {
    width: 100%;
  }
  #live-chat {
    bottom: 0;
    font-size: 12px;
    right: 24px;
    position: absolute;
    width: 300px;
  }
}
</style>
